export default __webpack_public_path__ + "static/media/R60.33dc0e92.png";